import { SettingsService } from './../settings.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-sms-settings',
    templateUrl: './sms-settings.component.html',
    styleUrls: ['./sms-settings.component.scss'],
    standalone: false
})
export class SmsSettingsComponent implements OnInit {
  smsForm: FormGroup;
  saveSuccessfullyMsg=false
  constructor(private fb: FormBuilder,public settingService:SettingsService) { }

  ngOnInit(): void {
    this.resetForm()
    this.settingService.getSmsData().subscribe((data)=>{
      this.smsForm.patchValue({
        Address: data.Address,
        wazeLink: data.wazeLink,
        instructionsLink: data.instructionsLink,
        phone: data.phone
      });
    })
  }



  resetForm(){
    this.smsForm = this.fb.group({
      Address: [''],
      wazeLink: [''],
      instructionsLink: [''],
      phone:['']
    });
  }

  onSubmit(): void {
    if (this.smsForm.valid) {
      this.settingService.sendSmsData(this.smsForm.value).subscribe((data)=>{
       this.saveSuccessfullyMsg=true
      })
     
      
    }
  }

}
